<template>
    <a-modal title="添加人员" :keyboard="false" :maskClosable="false" :width="1400" :open="true" @ok="onFormSubmit" @cancel="
        () => {
            $emit('cancel')
        }
    ">
        <a-form ref="personForm" :model="state.tableData[0]" :rules="personRules" :label-col="{ span: 8 }"
            :wrapper-col="{ span: 12 }">
            <div class="information">
                <div class="information-right">
                    <a-spin :spinning="state.loading_front">
                        <a-upload list-type="picture-card" accept=".jpeg,.png,.jpg" class="avatar-uploader"
                            :show-upload-list="false" :before-upload="beforeUpload" @change="
                                (info) => {
                                    handleChange(info, 'id_card_front')
                                }
                            ">
                            <img class="upload-img" type="" v-if="state.tableData[0].id_card_front"
                                :src="$store.state.user.image_domain + state.tableData[0].id_card_front" alt="avatar" />
                            <div v-else class="upload-img">
                                <PlusOutlined />
                                <div class="ant-upload-text">上传人员身份证照片(人像面)</div>
                            </div>
                        </a-upload>
                    </a-spin>
                    <a-spin :spinning="state.loading_back">
                        <a-upload list-type="picture-card" class="avatar-uploader" accept=".jpeg,.png,.jpg"
                            :show-upload-list="false" :before-upload="beforeUpload" @change="
                                (info) => {
                                    handleChange(info, 'id_card_back')
                                }
                            ">
                            <img class="upload-img" v-if="state.tableData[0].id_card_back"
                                :src="$store.state.user.image_domain + state.tableData[0].id_card_back" alt="avatar" />
                            <div v-else class="upload-img">
                                <PlusOutlined />
                                <div class="ant-upload-text">上传人员身份证照片(国徽面)</div>
                            </div>
                        </a-upload>
                    </a-spin>
                </div>

                <!--2026-05-20取消 <a-col :md="6" :offset="0" :sm="24" v-if="props.main_type == 2">
                    <a-form-item label="用户头像寸照" name="one_inch_picture">
                        <a-upload list-type="picture-card" accept=".jpeg,.png,.jpg" :show-upload-list="false"
                            :before-upload="beforeUpload" @change="
                                (info) => {
                                    handleImageChange(info, 'one_inch_picture')
                                }
                            ">
                            <img class="one_inch_picture" v-if="state.tableData[0].one_inch_picture"
                                :src="$store.state.user.image_domain + state.tableData[0].one_inch_picture"
                                alt="avatar" />
                            <div v-else>
                                <PlusOutlined />
                                <div class="ant-upload-text">上传用户头像寸照</div>
                            </div>
                        </a-upload>
                        <div v-if="props.platform_id == 12">左家塘地址不能身份证截图，必须自拍照。</div>
                    </a-form-item>
                </a-col> -->
            </div>
            <a-table :columns="columns" :data-source="state.tableData" :pagination="false">
                <template #headerCell="{ column }">
                    <template v-if="column.dataIndex === 'id_card_number'">
                        <span> 身份证号码 </span>
                    </template>
                    <template v-else-if="column.dataIndex === 'address'">
                        <span> 住址 </span>
                    </template>
                </template>
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex === 'name'">
                        <a-form-item class="m-0" name="name" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }">
                            <a-input placeholder="姓名" v-model:value="record.name"></a-input>
                        </a-form-item>
                    </template>
                    <template v-else-if="column.dataIndex === 'gender'">
                        <a-form-item class="m-0" name="gender" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }">
                            <a-select allow-clear style="width: 80px" v-model:value="record.gender" placeholder="性别">
                                <a-select-option :value="1"> 男</a-select-option>
                                <a-select-option :value="2"> 女</a-select-option>
                            </a-select>
                        </a-form-item>
                    </template>
                    <template v-else-if="column.dataIndex === 'nationality'">
                        <a-form-item class="m-0" name="nationality" :label-col="{ span: 0 }"
                            :wrapper-col="{ span: 24 }">
                            <a-select allow-clear v-model:value="record.nationality" placeholder="民族">
                                <a-select-option :value="item" v-for="(item, index) in state.nationalityList"
                                    :Key="index"> {{ item }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </template>
                    <template v-else-if="column.dataIndex === 'id_card_number'">
                        <a-form-item class="m-0" name="id_card_number" :label-col="{ span: 0 }"
                            :wrapper-col="{ span: 24 }">
                            <a-input placeholder="身份证" v-model:value="record.id_card_number"></a-input>
                        </a-form-item>
                    </template>
                    <template v-else-if="column.dataIndex === 'address'">
                        <a-form-item class="m-0" name="address" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }">
                            <a-input placeholder="地址" v-model:value="record.address"></a-input>
                        </a-form-item>
                    </template>
                    <template v-else-if="column.dataIndex === 'id_card_validity_start'">
                        <a-form-item class="m-0" name="id_card_validity_start" :label-col="{ span: 0 }"
                            :wrapper-col="{ span: 24 }">
                            <a-date-picker placeholder="身份证开始日期" format="YYYY-MM-DD"
                                v-model:value="record.id_card_validity_start" />
                        </a-form-item>
                    </template>
                    <template v-else-if="column.dataIndex === 'id_card_validity_end'">
                        <a-form-item class="m-0" name="id_card_validity_end" :label-col="{ span: 0 }"
                            :wrapper-col="{ span: 24 }">
                            <a-form-item-rest>
                                <a-date-picker placeholder="身份证结束日期" format="YYYY-MM-DD"
                                    v-model:value="record.id_card_validity_end" style="width: 140px" class="mr-1x"
                                    :disabled="state.tableData[0].identity_perpetual == 1" />
                            </a-form-item-rest>
                            <a-form-item-rest>
                                <a-checkbox :checked="state.tableData[0].identity_perpetual == 1 ? true : false"
                                    @change="identityPerpetualChange">长期</a-checkbox>
                            </a-form-item-rest>
                        </a-form-item>
                    </template>
                </template>
            </a-table>
            <a-row class="mt-1x">
                <a-col :md="5" :offset="0" :sm="24">
                    <a-form-item label="出资金额" name="investment_money">
                        <a-input type="number" addon-after="万元" v-model:value="state.tableData[0].investment_money"
                            placeholder="出资金额"></a-input>
                    </a-form-item>
                </a-col>
                <a-col :md="9" :offset="0" :sm="24">
                    <a-form-item label="预留到工商电话" name="phone_number" :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }">
                        <a-row>
                            <a-col :span="12">
                                <a-input @change="
                                    (v) => {
                                        phoneChange(v, 'phone_number')
                                    }
                                " placeholder="请输入手机号码" :value="state.tableData[0].phone_number"></a-input>
                            </a-col>
                            <a-col :span="12"><a-button class="ml-1x" type="primary" @click="() => {
                                state.tableData[0].phone_number = props.registration_mobile
                            }">填入工商预留号码</a-button></a-col>
                        </a-row>
                    </a-form-item>
                </a-col>
                <a-col :md="10" :offset="0" :sm="24">
                    <a-form-item label="本人过风控实名电话" name="phone_number_fengkong" :labelCol="{ span: 8 }"
                        :wrapperCol="{ span: 16 }">
                        <a-row>
                            <a-col :span="12">
                                <a-input @change="
                                    (v) => {
                                        phoneChange(v, 'phone_number_fengkong')
                                    }
                                " placeholder="请输入手机号码"
                                    :value="state.tableData[0].phone_number_fengkong"></a-input></a-col>
                            <a-col :span="12"><a-button class="ml-1x" type="primary" @click="() => {
                                state.tableData[0].phone_number_fengkong = props.registration_mobile
                            }">填入工商预留号码</a-button></a-col>
                        </a-row>
                    </a-form-item>
                </a-col>
            </a-row>
        </a-form>
        <image-cropper @cancel="
            () => {
                state.showCropper = false
            }
        " isId :imageUrl="state.imageUrl" :imageName="state.imageName"
            :upload_path="`public/uploads/注册/${props.uploadPathObj?.platformCompanyName}/客户资料/${props.uploadPathObj?.mainTypeName}/${props.uploadPathObj?.date}/${props.uploadPathObj?.companyName}/`"
            :customerName="props.customerName" :maxKbSize="950" :isTiqianClose="true" @change="cropperPost"
            v-if="state.showCropper"></image-cropper>
        <image-cropper @cancel="
            () => {
                state.showImageCropper = false
            }
        " :windowsSize="[130, 180]" :isId="false" :imageUrl="state.imageUrl" :imageName="state.imageName"
            :maxKbSize="950" @change="cropperImageChange"
            :upload_path="`public/uploads/注册/${props.uploadPathObj?.platformCompanyName}/客户资料/${props.uploadPathObj?.mainTypeName}/${props.uploadPathObj?.date}/${props.uploadPathObj?.companyName}/`"
            :customerName="props.customerName" v-if="state.showImageCropper"></image-cropper>
    </a-modal>
</template>

<script lang="ts" setup>
import baseService from '@/utils/http/axios'
import { PlusOutlined } from '@ant-design/icons-vue'
import ImageCropper from '@/components/ImageCropper/index.vue'
import cloneDeep from 'lodash.clonedeep'
import { reactive, ref, computed, onMounted, PropType } from 'vue'
import { message } from 'ant-design-vue'
import { mobileRequiredValidator } from '@/utils/util'
import dayjs from 'dayjs'
import { useStore } from 'vuex'
import { getAgeByIdCard } from '@/utils/util'
let dayTime = dayjs()
const $store = useStore()
const format = 'YYYY-MM-DD'
interface tableData {
    // 职位
    position_ids: number[]
    // 名称
    name: string | null
    // 性别
    gender: string | null
    // 民族
    nationality: string | null
    // 身份证号码
    id_card_number: string | null
    // 地址
    address: string | null
    // 是否为长期
    identity_perpetual: number | null
    // 身份证日期开始时间
    id_card_validity_start: string | null
    // 身份证日期截止时间
    id_card_validity_end: string | null
    // 身份证正面照片
    id_card_front: string | null
    // 身份证反面照片
    id_card_back: string | null
    // 手机号
    phone_number: string | null
    phone_number_fengkong: string | null
    // 编辑或者新增
    type: string | null
    // 出资金额
    investment_money: number | null
    // 是否占股
    is_shareholder: number | null
    id?: number
    edit_code?: string
    one_inch_picture: string
}

const props = defineProps({
    // 人员数据
    employmentData: {
        type: Object as PropType<tableData>
    },
    isEdit: {
        type: Boolean
    },
    uploadPathObj: {
        type: Object
    },
    customerName: {
        type: String
    },
    platform_id: {
        type: Number || null
    },
    main_type: {
        type: Number,
        default: 2
    },
    registration_mobile: {
        type: String,
        default: ''
    }
})
let validateEnd = (rule, value) => {
    if (!value && state.tableData[0].identity_perpetual != 1) {
        return Promise.reject(new Error('请选择身份证结束日期'))
    } else if (value && state.tableData[0].identity_perpetual != 1) {
        const start = dayjs(value, 'YYYY-MM-DD')
        const diff = start.diff(dayTime, 'day')
        if (diff < 7) {
            return Promise.reject(new Error('身份证结束日期不能少于7天'))
        } else {
            return Promise.resolve()
        }
    } else {
        return Promise.resolve()
    }
}
let idNumberValidator = (rule, value) => {
    let reg_tel = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    if (value && value.length > 0) {
        if (!reg_tel.test(value)) {
            return Promise.reject('身份证号码不正确')
        } else {
            return Promise.resolve()
        }
    } else {
        return Promise.reject('请输入身份证号码')
    }
}
const personRules = {
    investment_money: [{ required: true, message: '请输入出资金额', trigger: 'change' }],
    name: [{ required: true, message: '请填写姓名', trigger: 'change' }],
    gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
    nationality: [{ required: true, message: '请填写名族', trigger: 'change' }],
    id_card_number: [{ validator: idNumberValidator, trigger: 'change' }],
    address: [{ required: true, message: '请填写地址', trigger: 'change' }],
    id_card_validity_start: [{ required: true, message: '请选择身份证开始日期', trigger: 'change' }],
    id_card_validity_end: [{ validator: validateEnd, trigger: 'change' }],
    phone_number: [{ required: true, validator: mobileRequiredValidator, trigger: 'change' }],
    phone_number_fengkong: [{ required: true, validator: mobileRequiredValidator, trigger: 'change' }]
}
const columns = [
    {
        // 默认货币
        title: '姓名',
        dataIndex: 'name',
        width: 80
    },
    {
        title: '性别',
        dataIndex: 'gender',
        width: 50
    },
    {
        // 默认货币
        title: '身份证号码',
        dataIndex: 'id_card_number',
        width: 150
    },
    {
        title: '住所',
        dataIndex: 'address',
        width: 180
    },
    {
        title: '民族',
        dataIndex: 'nationality',
        width: 90
    },
    {
        title: '身份证有效期开始日期',
        dataIndex: 'id_card_validity_start',
        width: 130
    },
    {
        title: '身份证有效期结束日期',
        dataIndex: 'id_card_validity_end',
        width: 120
    }
]
interface state {
    // 图片裁剪
    showCropper: boolean
    showImageCropper: boolean
    // 当前上传身份证的字段
    currentUpload: string
    // 表格数据
    tableData: tableData[]
    // 进行裁剪的图片地址
    imageUrl: string
    imageName: string

    nationalityList: string[]
    loading_front: boolean
    loading_back: boolean
}
const state = reactive<state>({
    // 图片裁剪
    showCropper: false,
    showImageCropper: false,
    // 当前上传身份证的字段
    currentUpload: '',
    // 表格数据
    tableData: [
        {
            // 名称
            name: null,
            // 性别
            gender: null,
            position_ids: [1],
            // 民族
            nationality: null,
            // 身份证号码
            id_card_number: null,
            // 地址
            address: null,
            // 是否为长期
            identity_perpetual: 2,
            // 身份证日期开始时间
            id_card_validity_start: null,
            // 身份证日期截止时间
            id_card_validity_end: null,
            // 身份证正面照片
            id_card_front: null,
            // 身份证反面照片
            id_card_back: null,
            // 手机号
            phone_number: null,
            phone_number_fengkong: null,
            // 编辑或者新增
            type: 'add',
            // 出资金额
            investment_money: 1,
            // 默认占股 出资截止日期为空
            is_shareholder: 1,
            one_inch_picture: '',
        }
    ],
    // 进行裁剪的图片地址
    imageUrl: '',
    imageName: '',
    nationalityList: [
        '汉族',
        '蒙古族',
        '回族',
        '藏族',
        '维吾尔族',
        '苗族',
        '彝族',
        '壮族',
        '布依族',
        '朝鲜族',
        '满族',
        '侗族',
        '瑶族',
        '白族',
        '土家族',
        '哈尼族',
        '哈萨克族',
        '傣族',
        '黎族',
        '傈僳族',
        '佤族',
        '畲族',
        '高山族',
        '拉祜族',
        '水族',
        '东乡族',
        '纳西族',
        '景颇族',
        '柯尔克孜族',
        '土族',
        '达斡尔族',
        '仫佬族',
        '羌族',
        '布朗族',
        '撒拉族',
        '毛难族',
        '仡佬族',
        '锡伯族',
        '阿昌族',
        '普米族',
        '塔吉克族',
        '怒族',
        '乌孜别克族',
        '俄罗斯族',
        '鄂温克族',
        '崩龙族',
        '保安族',
        '裕固族',
        '京族',
        '塔塔尔族',
        '独龙族',
        '额伦春族',
        '赫哲族',
        '门巴族',
        '洛巴族',
        '基诺族',
        '其他',
        '外国血统中国籍人士'
    ],
    loading_front: false,
    loading_back: false
})
const personForm = ref()
const emit = defineEmits(['change', 'cancel'])
onMounted(() => {
    if (props.employmentData?.type == 'edit') {
        true
        let employmentData = cloneDeep(props.employmentData)
        if (employmentData.investment_money) {
            employmentData.investment_money = Number(employmentData.investment_money)
        }
        employmentData.id_card_validity_end = dayjs(employmentData.id_card_validity_end, format)
        employmentData.id_card_validity_start = dayjs(employmentData.id_card_validity_start, format)
        state.tableData = [employmentData]
    }

    console.log(props)
})
const identityPerpetualChange = (val) => {
    state.tableData[0].identity_perpetual = val.target.checked ? 1 : 2
    personForm.value.validateField('id_card_validity_end')
}
// 提交
const onFormSubmit = () => {
    // 身份证信息验证
    if (!state.tableData[0].id_card_front || !state.tableData[0].id_card_back /*|| (!state.tableData[0].one_inch_picture && props.main_type == 2)*/) {
        message.error('请上传身份证正、反面照片或寸照！')
        return
    }
    personForm.value
        .validate()
        .then((valid: any) => {
            if (valid) {
                if (props.isEdit) {
                    if (state.tableData[0].id) {
                        state.tableData[0].edit_code = 'edit'
                    } else {
                        state.tableData[0].edit_code = 'add'
                    }
                }
                state.tableData[0].id_card_validity_end = dayjs(state.tableData[0].id_card_validity_end).format(format)
                state.tableData[0].id_card_validity_start = dayjs(state.tableData[0].id_card_validity_start).format(format)
                emit('change', state.tableData[0])
            }
        })
        .catch(() => {
            message.warning(res.msg)
        })
}
const phoneChange = (v, type) => {
    let str = v.target.value.replaceAll(/\D/g, '')
    state.tableData[0][type] = str
}
// 图片上传
const handleChange = (info, type) => {
    state.currentUpload = type
    const reader: any = new FileReader()
    //   const isGt1M = info.file.size / 1024 / 1024 > 1
    //   if (isGt1M) {
    //     message.error('图片必须小于1MB!')
    //     return
    //   }
    state.imageName = info.file.name
    reader.readAsDataURL(info.file)
    reader.onload = () => {
        state.imageUrl = reader.result
        state.showCropper = true
    }
}

const handleImageChange = (info, type) => {
    state.currentUpload = type
    const reader: any = new FileReader()
    //   const isGt1M = info.file.size / 1024 / 1024 > 1
    //   if (isGt1M) {
    //     message.error('图片必须小于1MB!')
    //     return
    //   }
    state.imageName = info.file.name
    reader.readAsDataURL(info.file)
    reader.onload = () => {
        state.imageUrl = reader.result
        state.showImageCropper = true
    }
}
// 裁剪成功
const cropperImageChange = (res) => {
    state.tableData[0].one_inch_picture = res.url
    state.showImageCropper = false
    personForm.value.validate('one_inch_picture')
}

//上传裁剪后的图片
const cropperPost = (formData, isRecognize) => {
    //这个变量会在点另一个的时候变化，先记录一下再关闭窗口
    let currentUpload = state.currentUpload
    state.showCropper = false
    if (currentUpload == 'id_card_front') {
        state.loading_front = true
    } else if (currentUpload == 'id_card_back') {
        state.loading_back = true
    }
    if (isRecognize) {
        let requestParam = {
            url: '/admin/v1/ocr',
            method: 'post',
            data: formData
        }
        baseService(requestParam)
            .then((res) => {
                if (currentUpload == 'id_card_front') {
                    state.loading_front = false
                } else if (currentUpload == 'id_card_back') {
                    state.loading_back = false
                }
                cropperChange(res, isRecognize, currentUpload)
            })
            .catch((res) => {
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('操作失败')
                }
                if (currentUpload == 'id_card_front') {
                    state.loading_front = false
                } else if (currentUpload == 'id_card_back') {
                    state.loading_back = false
                }
            })
    } else {
        let requestParam = {
            url: '/admin/v1/upload',
            method: 'post',
            data: formData
        }
        baseService(requestParam)
            .then((res) => {
                if (currentUpload == 'id_card_front') {
                    state.loading_front = false
                } else if (currentUpload == 'id_card_back') {
                    state.loading_back = false
                }
                cropperChange(res.data, isRecognize, currentUpload)
            })
            .catch((res) => {
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('操作失败')
                }
                if (currentUpload == 'id_card_front') {
                    state.loading_front = false
                } else if (currentUpload == 'id_card_back') {
                    state.loading_back = false
                }
            })
    }
}
// 裁剪成功
const cropperChange = (res, isRecognize, currentUpload) => {
    if (isRecognize) {
        let data = res.data.身份证识别实体信息
        if (currentUpload == 'id_card_back') {
            if (data.身份证国徽面实体信息.有效期限.length < 1) {
                message.error('请上传身份证正面照片（国徽面）')
                state.tableData[0].id_card_back = ''
                return
            }
            let list = data.身份证国徽面实体信息.有效期限.split('-').map((item, index) => {
                return item.replaceAll('.', '-')
            })
            let obj = {
                id_card_validity_start: dayjs(list[0], format),
                id_card_validity_end: dayjs(list[1], format),
                identity_perpetual: list[1] == '长期' ? 1 : 2
            }
            Object.assign(state.tableData[0], obj)
        } else if (currentUpload == 'id_card_front') {
            if (data.身份证人像面实体信息.姓名.length < 1) {
                message.error('请上传身份证反面照片（人像面）')
                state.tableData[0].id_card_front = ''
                return
            }
            let nationality: any = null
            state.nationalityList.forEach((item) => {
                if (item.indexOf(data.身份证人像面实体信息.民族) > -1) {
                    nationality = item
                }
            })
            let obj = {
                name: data.身份证人像面实体信息.姓名,
                address: data.身份证人像面实体信息.住址,
                id_card_number: data.身份证人像面实体信息.身份证号,
                gender: data.身份证人像面实体信息.性别 == '男' ? 1 : 2,
                nationality: nationality
            }
            Object.assign(state.tableData[0], obj)
        }
        state.tableData[0][currentUpload] = res.data.url
    } else {
        state.tableData[0][currentUpload] = res.url
    }
}
// 手动上传验证
const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
        message.error('请上传正确图片！')
    }
    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
        message.error('图片必须小于2MB!')
    }
    return false
}
</script>

<style lang="less" scoped>
.information {
    display: flex;
    justify-content: center;
}

.information-right {
    display: flex;
    justify-content: center;
}

.information-card {
    margin-bottom: 20px;
    border-radius: 10px;

    :deep(.ant-card-head) {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        background: #40a9ff;
        color: #fff;
    }
}

.avatar-uploader {
    :deep(.ant-upload.ant-upload-select-picture-card) {
        width: 300px !important;
        height: 200px !important;
    }
}

.one_inch_picture {
    width: 100px;
    height: 100px;
}

.upload-img {
    width: 300px;
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

:deep(.ant-table-thead > tr > th, .ant-table-tbody > tr > td) {
    padding-left: 28px;
}

.category {
    padding-top: 30px;
    display: flex;
    justify-content: space-around;

    .category-item {
        font-size: 24px;
        cursor: pointer;
        padding: 50px;
        border-radius: 15px;
        width: 100%;
        margin-right: 20px;
        text-align: center;
    }
}

.m-0 {
    :deep(.ant-form-explain) {
        position: absolute;
    }
}
</style>
